export const SIGNATURE_BLOCK_SELECTOR = '[data-signature="true"], #email-signature';
export const SIGNATURE_ROW_ID_PREFIX = 'signature_row_';
export const SIGNATURE_COLUMN_ID_PREFIX = 'signature_column_';
